import { DealDateCell } from './DealDateCell';

export default DealDateCell;
